<template>
  <div v-loading="loading">
    <div v-if="variants.length">
      <div v-for="variant in variants" :key="variant.id" class="mb-5">
        <div class="d-flex justify-content-between">
          <div>
            <h3 class="mb-4">{{ variant.barcode.type }}: {{ variant.barcode.value }}</h3>
          </div>
          <div>
            <el-button-group>
              <el-button size="small" :disabled="variant.sort === 1" icon="el-icon-arrow-up" @click="onOrder(variant.id, variant.sort - 1)"></el-button>
              <el-button size="small" :disabled="variant.sort === variants.length" icon="el-icon-arrow-down" @click="onOrder(variant.id, variant.sort + 1)"></el-button>
            </el-button-group>
          </div>
        </div>
        <p>Color: <strong>{{ variant.color }}</strong></p>
        <p>Size: <strong>{{ variant.size }}</strong></p>
        <div class="row">
          <div class="col-3">
            Width (cm): <strong>{{ variant.width }}</strong>
          </div>
          <div class="col-3">
            Height (cm): <strong>{{ variant.height }}</strong>
          </div>
          <div class="col-3">
            Length (cm): <strong>{{ variant.length }}</strong>
          </div>
          <div class="col-3">
            Weight (g): <strong>{{ variant.weight }}</strong>
          </div>
        </div>
        <product-item-variant-image :variant="variant" />
        <product-item-variant-view :productSlug="product.slug" :variantId="variant.id" />
        <product-item-variant-edit :variant="variant" @update="refreshVariants" />
        <product-item-variant-move :productId="product.id" :variantId="variant.id" @update="refreshVariants" />
        <product-item-variant-delete :variantId="variant.id" @delete="refreshVariants" />
        <product-item-inventory :variantId="variant.id" />
      </div>
    </div>
    <div v-else class="text-center">
      <p>No variants were found.</p>
    </div>
    <section class="my-4">
      <product-item-variant-create :productId="product.id" @create="refreshVariants" />
    </section>
  </div>
</template>

<script>
import ProductItemInventory from '@/components/Product/Item/ProductItemInventory'
import ProductItemVariantCreate from '@/components/Product/Item/ProductItemVariantCreate'
import ProductItemVariantImage from '@/components/Product/Item/ProductItemVariantImage'
import ProductItemVariantView from '@/components/Product/Item/ProductItemVariantView'
import ProductItemVariantEdit from '@/components/Product/Item/ProductItemVariantEdit'
import ProductItemVariantMove from '@/components/Product/Item/ProductItemVariantMove'
import ProductItemVariantDelete from '@/components/Product/Item/ProductItemVariantDelete'

export default {
  components: {
    ProductItemInventory,
    ProductItemVariantCreate,
    ProductItemVariantImage,
    ProductItemVariantView,
    ProductItemVariantEdit,
    ProductItemVariantMove,
    ProductItemVariantDelete,
  },

  props: {
    product: Object,
  },

  data() {
    return {
      loading: false,
      variants: this.product.variants,
    }
  },

  methods: {
    async refreshVariants() {
      this.loading = true

      try {
        var { data } = await this.$http.get(`/products/${ this.product.id }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.variants = data.variants
    },

    async onOrder(variantId, order) {
      try {
        var { data } = await this.$http.put(`/product-variants/${ variantId }`, {
          order: order,
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }

      this.refreshVariants()
    },
  },
}
</script>
